import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "agencyBloc",
    "unavailableBloc",
    "alertRecontact",
    "keyOwnerBloc",
    "inventoryContactBloc",
  ]

  connect() {
    this.updateAgency()
    this.updateAvailability()
    this.updateKeys()
    this.updateInventory()
  }

  updateAgency() {
    this.agencyBlocTarget.classList.add("hidden")
    const checked = this.element.querySelector("[name='activation[reprise_agence]']:checked")
    if (!checked)
      return
    const val = checked.value
    if (val == "true")
      this.agencyBlocTarget.classList.remove("hidden")
  }

  updateAvailability() {
    this.unavailableBlocTarget.classList.add("hidden")
    this.alertRecontactTarget.classList.add("hidden")
    const checked = this.element.querySelector("[name='activation[is_ready]']:checked")
    if (!checked)
      return
    const val = checked.value
    if (["partly", "not-ready"].includes(val)) {
      this.unavailableBlocTarget.classList.remove("hidden")
      if (val == "not-ready")
        this.alertRecontactTarget.classList.remove("hidden")
    }
  }

  updateKeys() {
    this.keyOwnerBlocTarget.classList.add("hidden")
    const checked = this.element.querySelector("[name='activation[key_owner]']:checked")
    if (!checked)
      return
    const val = checked.value
    if (val == "other") {
      this.keyOwnerBlocTarget.classList.remove("hidden")
    }
  }

  updateInventory() {
    this.inventoryContactBlocTarget.classList.add("hidden")
    const checked = this.element.querySelector("[name='activation[inventory_contact]']:checked")
    if (!checked)
      return
    const val = checked.value
    if (val == "other") {
      this.inventoryContactBlocTarget.classList.remove("hidden")
    }
  }
}
